<template>
  <article v-html="html" class="markdown" />
</template>

<script setup>
import { computed } from 'vue';
import { marked } from 'marked';

const props = defineProps({content: String});
const html = computed(() => marked(props.content ?? ''));
</script>

<style scoped>
.markdown
{
  @apply py-6 px-4 sm:p-6 lg:pb-8;
  @apply prose prose-base max-w-none;
}
</style>
